import IMask from "imask";
import { FORM_SELECTORS, VALIDATION_CONSTANTS } from "./const.js";

/**
 * Класс для валидации форм
 * @class FormValidator
 *
 * @property {HTMLFormElement} form - Форма для валидации
 * @property {HTMLButtonElement} submitButton - Кнопка отправки формы
 * @property {HTMLInputElement} phoneInput - Поле ввода телефона
 * @property {HTMLInputElement} acceptanceCheckbox - Чекбокс согласия
 * @property {IMask} phoneMask - Экземпляр IMask для маскирования телефона
 */
export default class FormValidator {
  /**
   * Создает экземпляр FormValidator
   * @param {HTMLElement} container - Обёртка формы
   */
  constructor(container) {
    this.container = container;
    this.form = container?.querySelector(FORM_SELECTORS.FORM);
    this.submitButton = this.form?.querySelector(FORM_SELECTORS.SUBMIT_BUTTON);
    this.phoneInput = this.form?.querySelector(FORM_SELECTORS.PHONE_INPUT);
    this.acceptanceCheckbox = this.form?.querySelector(
      FORM_SELECTORS.ACCEPTANCE_CHECKBOX,
    );
  }

  /**
   * Инициализирует валидацию формы
   * @returns {void}
   */
  init() {
    if (!this.validateElements()) {
      console.error("Form elements not found");

      return;
    }

    this.initPhoneMask();
    this.initValidation();
  }

  /**
   * Проверяет наличие всех необходимых элементов формы
   * @returns {boolean}
   */
  validateElements() {
    return this.submitButton && this.phoneInput && this.acceptanceCheckbox;
  }

  /**
   * Инициализирует маску для поля телефона
   * @returns {void}
   */
  initPhoneMask() {
    this.phoneMask = IMask(this.phoneInput, {
      mask: "+{7} (000) 000-00-00",
      lazy: false,
    });
  }

  /**
   * Инициализирует валидацию формы
   * @returns {void}
   */
  initValidation() {
    this.disableSubmitButton();
    this.addEventListeners();
    this.validateForm();
  }

  /**
   * Отключает кнопку отправки формы
   * @returns {void}
   */
  disableSubmitButton() {
    this.submitButton.disabled = true;
  }

  /**
   * Включает кнопку отправки формы
   * @returns {void}
   */
  enableSubmitButton() {
    this.submitButton.disabled = false;
  }

  /**
   * Валидирует форму: телефон и чекбокс согласия
   * @returns {void}
   */
  validateForm() {
    const phoneValid =
      this.phoneMask.unmaskedValue.length === VALIDATION_CONSTANTS.PHONE_LENGTH;
    const acceptanceChecked = this.acceptanceCheckbox.checked;

    if (phoneValid && acceptanceChecked) {
      this.enableSubmitButton();
    } else {
      this.disableSubmitButton();
    }
  }

  /**
   * Добавляет обработчики событий
   * @returns {void}
   */
  addEventListeners() {
    this.phoneInput.addEventListener("change", () => this.validateForm());
    this.acceptanceCheckbox.addEventListener("change", () =>
      this.validateForm(),
    );
    this.form.addEventListener("submit", () => this.disableSubmitOnSubmit());
  }

  /**
   * Отключает кнопку отправки при submit события
   * @returns {void}
   */
  disableSubmitOnSubmit() {
    this.submitButton.disabled = true;
  }
}
